import AllinaLogo from '../images/allina-square.png';
import ABLogo from '../images/assistans-bolaget-square.png';
import AvonovaLogo from '../images/avonova-square.png';
import AvonovaNoLogo from '../images/avonova-no-square.png';
import BalderLogo from '../images/balder-square.png';
import BrunskogsLogo from '../images/brunskogs-square.png';
import BsbLogo from '../images/bsb-square.png';
import CircleKLogo from '../images/cirkle-k-square.png';
import CoverMeLogo from '../images/cover_me.png';
import CroisetteLogo from '../images/croisette-square.png';
import CyviLogo from '../images/cyvi.png';
import DigisureLogo from '../images/digisure-square.png';
import EasyPeasyLogo from '../images/easypeasy-square.png';
import EirLogo from '../images/eir-square.png';
import EvoliLogo from '../images/evoli-square.png';
import FairNoLogo from '../images/fair-no-square.png';
import FairSeLogo from '../images/fair-se-square.png';
import FmfLogo from '../images/fmf-square.png';
import GarboLogo from '../images/garbo-square.png';
import GlobalLinkLogo from '../images/global-link-square.png';
import GofidoLogo from '../images/gofido-square.png';
import HajpeLogo from '../images/hajpe-square.png';
import HedvigLogo from '../images/hedvig-square.png';
import HvildLogo from '../images/hvild.png';
import JobbgarantLogo from '../images/jobbgarant-square.png';
import LinLogo from '../images/lin-square.png';
import MaxusLogo from '../images/maxus-square.png';
import MehrwerkLogo from '../images/mehrwerk-square.png';
import OnuavaLogo from '../images/onuava-square.png';
import PetsonLogo from '../images/petson-square.png';
import SbmLogo from '../images/sbm-square.png';
import SensorLogo from '../images/senor-square.png';
import StormLogo from '../images/storm-square.png';
import SumitLogo from '../images/sumit-square.png';
import SwedvaultLogo from '../images/swedvault-square.png';
import TaxiLogo from '../images/taxi-square.png';
import TillitLogo from '../images/tillit-square.png';
import TtLogo from '../images/tt-square.png';
import VarsamLogo from '../images/varsam-square.png';
import WrittenLogo from '../images/written-square.png';
import ZmartaLogo from '../images/zmarta-square.png';

export const partnersConfig: {
  [partnerName: string]: { name: string; logo: string };
} = {
  allina: { name: 'Allina', logo: AllinaLogo },
  ab: { name: 'Assistansbolaget', logo: ABLogo },
  avonova: { name: 'Avonova', logo: AvonovaLogo },
  avonovanorge: { name: 'Avonova Norge', logo: AvonovaNoLogo },
  balder: { name: 'Balder', logo: BalderLogo },
  brunskogs: { name: 'Brunskogs', logo: BrunskogsLogo },
  bsb: { name: 'BSB', logo: BsbLogo },
  circlek: { name: 'Cirkle-K', logo: CircleKLogo },
  coverme: { name: 'Cover Me', logo: CoverMeLogo },
  croisette: { name: 'Croisette', logo: CroisetteLogo },
  cyvi: { name: 'Cyvi', logo: CyviLogo },
  digisure: { name: 'Digisure', logo: DigisureLogo },
  easypeasy: { name: 'EasyPeasy', logo: EasyPeasyLogo },
  evoli: { name: 'Evoli', logo: EvoliLogo },
  fair: { name: 'Fair Sverige', logo: FairSeLogo },
  fairnorge: { name: 'Fair Norge', logo: FairNoLogo },
  fmf: { name: 'FMF', logo: FmfLogo },
  garbo: { name: 'Garbo', logo: GarboLogo },
  globelink: { name: 'Global Link', logo: GlobalLinkLogo },
  gofido: { name: 'Gofido', logo: GofidoLogo },
  hajpe: { name: 'Hajpe', logo: HajpeLogo },
  hedvig: { name: 'Hedvig', logo: HedvigLogo },
  hvild: { name: 'Hvild', logo: HvildLogo },
  jobbgarant: { name: 'Jobbgarant', logo: JobbgarantLogo },
  lin: { name: 'Lin', logo: LinLogo },
  maxus: { name: 'Maxus', logo: MaxusLogo },
  mehrwerk: { name: 'Mehrwerk', logo: MehrwerkLogo },
  onuava: { name: 'Onuava', logo: OnuavaLogo },
  norsktaxi: { name: 'Norsk Taxi', logo: TaxiLogo },
  petson: { name: 'Petson', logo: PetsonLogo },
  sbm: { name: 'SBM', logo: SbmLogo },
  sensor: { name: 'Sensor', logo: SensorLogo },
  storm: { name: 'Storm', logo: StormLogo },
  sumit: { name: 'Sumit', logo: SumitLogo },
  swedvault: { name: 'Swedvault', logo: SwedvaultLogo },
  tillit: { name: 'Tillit', logo: TillitLogo },
  ttforsikring: { name: 'TT Forsikring', logo: TtLogo },
  varsam: { name: 'Varsam', logo: VarsamLogo },
  written: { name: 'Written', logo: WrittenLogo },
  zmarta: { name: 'Zmarta', logo: ZmartaLogo },
  default: { name: 'default', logo: EirLogo },
};
